import { temAcesso } from '@/shared/auth/temAcesso'

const Servicos = () => import('./Servicos.vue')
const ServicoDetalhar = () => import('./ServicoDetalhar.vue')

export default {
    path: 'servicos',
    name: 'Fornecedor_Contratos_Servicos',
    component: Servicos,
    beforeEnter: (to, from, next) => {
        if (temAcesso('GESCON-FORN-SERV-00')) {
            next()
        }
    },
    children: [
        {
            path: '',
            name: 'Fornecedor_Contratos_Servicos_Listagem',
            component: Servicos,
            beforeEnter: (to, from, next) => {
                if (temAcesso('GESCON-FORN-SERV-00')) {
                    next()
                }
            }
        },
        {
            path: ':comprometimentoId',
            name: 'Fornecedor_Contratos_Servicos_Detalhar',
            component: ServicoDetalhar,
            beforeEnter: (to, from, next) => {
                if (temAcesso('GESCON-FORN-SERV-00')) {
                    next()
                }
            }
        }
    ]
}